import styled from '@emotion/styled';
import { breakpoints } from '~/theme';

export const StyledAccordionContainer = styled.div(({ theme }) => ({
    margin: `0 calc(${theme.gridConfig.gutter} * -1)`,
    [breakpoints.md]: {
        margin: 0,
    },
}));

export const StyledList = styled.ul(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: theme.spaces[2],
}));

export const StyledSizeActions = styled.div(({ theme }) => ({
    display: 'flex',
    alignItems: 'flex-end',
    flexWrap: 'wrap',
    minHeight: 30,
    gap: `${theme.spaces[2]} ${theme.spaces[4]}`,
    fontWeight: theme.text.weights.bold,
}));

export const StyledSizeGuideWrapper = styled.div({
    a: {
        // Makes sure strokeline is aligned with Easysize strokeline.
        // We can't control Easysize markup, so the strokeline is aligned with the wrapper of Easysize.
        // This means we have to make SizeGuide anchor inline-block, so the anchor does not have auto height,
        // but is based on lineheight instead.
        display: 'inline-block',
    },
});
